'use client';

import { ToggleGroup, ToggleGroupItem } from './ToggleGroup';

import type { DiffMode } from './DiffView';

export interface DiffModeToggleProps {
  mode: DiffMode;
  onModeChange: (mode: DiffMode) => void;
}

/** Unified / split segmented control that drives a `DiffView`'s `mode`. */
export function DiffModeToggle({ mode, onModeChange }: DiffModeToggleProps) {
  return (
    <ToggleGroup
      onValueChange={(value) => {
        if (value === 'unified' || value === 'split') onModeChange(value);
      }}
      size="sm"
      type="single"
      value={mode}
      variant="bounded"
    >
      <ToggleGroupItem value="unified">Unified</ToggleGroupItem>
      <ToggleGroupItem value="split">Split</ToggleGroupItem>
    </ToggleGroup>
  );
}
